/**
 * Properties Components Index
 * Core reusable property components
 */

export { PropertyCard } from './PropertyCard';
export type { PropertyCardProps } from './PropertyCard';

export { PropertyGrid } from './PropertyGrid';
export type { PropertyGridProps } from './PropertyGrid';

export { PropertyFeatureSection } from './PropertyFeatureSection';
export type { PropertyFeatureSectionProps } from './PropertyFeatureSection';

export { PropertyFinder } from './PropertyFinder';
export type { MapRendererProps, PropertyFinderProps } from './PropertyFinder';

export { PropertySearchBar } from './PropertySearchBar';
export type { PropertySearchBarProps, PropertySearchValues } from './PropertySearchBar';

export { FeaturedPropertiesCarousel } from '../core/FeaturedPropertiesCarousel';
export type { FeaturedPropertiesCarouselProps } from '../core/FeaturedPropertiesCarousel';

export { PropertyListCard } from './PropertyListCard';
export type { PropertyListCardProps } from './PropertyListCard';

export { ViewSwitcher } from './ViewSwitcher';
export type { ViewMode, ViewSwitcherProps } from './ViewSwitcher';

export { PropertySearchFilterToolbar } from './PropertySearchFilterToolbar';
export type { BasicFilter, PropertySearchFilterToolbarProps } from './PropertySearchFilterToolbar';

export { PropertyMapView } from './PropertyMapView';
export type { PropertyMapViewProps } from './PropertyMapView';

export { PropertyMapCard } from './PropertyMapCard';
export type { PropertyMapCardProps } from './PropertyMapCard';

export { PropertyListing } from './PropertyListing';
export type { PropertyListingProps, PropertyListingRenderProps } from './PropertyListing';

export { PropertyHero } from './PropertyHero';
export type { PropertyHeroProps } from './PropertyHero';

export { PropertyOverview } from './PropertyOverview';
export type { PropertyOverviewProps } from './PropertyOverview';

export { PropertyFeatures } from './PropertyFeatures';
export type { PropertyFeaturesProps } from './PropertyFeatures';

export { PropertyAmenities } from './PropertyAmenities';
export type { PropertyAmenitiesProps } from './PropertyAmenities';

export { PropertyGallery } from './PropertyGallery';
export type { PropertyGalleryProps } from './PropertyGallery';

export { PropertyGalleryLightbox } from './PropertyGalleryLightbox';

export { PropertyContactCard } from './PropertyContactCard';
export type { PropertyContactCardProps } from './PropertyContactCard';

export { PropertyViewingModal } from './PropertyViewingModal';
export type { PropertyViewingModalProps } from './PropertyViewingModal';

export { PropertyEnquiryModal } from './PropertyEnquiryModal';
export type { PropertyEnquiryModalProps } from './PropertyEnquiryModal';

export { PropertyLocation } from './PropertyLocation';
export type { PropertyLocationProps } from './PropertyLocation';

// Enhanced Property Details Components
export { PropertySpecifications } from './PropertySpecifications';
export type { PropertySpecificationsProps } from './PropertySpecifications';

export { PropertyValuations } from './PropertyValuations';
export type { PropertyValuationsProps } from './PropertyValuations';

export { 
  PropertyVirtualTour,
  PropertyVideos,
  PropertyFloorPlans,
  PropertyDocuments,
  groupMediaByContext,
} from './PropertyMedia';
export type { 
  PropertyVirtualTourProps,
  PropertyVideosProps,
  PropertyFloorPlansProps,
  PropertyDocumentsProps,
} from './PropertyMedia';
